// Shared styled IconButton for toolbar icons
import styled from 'styled-components';
import IconButton from '@mui/material/IconButton';

const IconButtonStyled = styled(IconButton)`
	background-color: transparent !important;
	border-radius: 50% !important;
	transition: background-color 0.15s ease !important;
	& svg {
		transition: transform 0.15s ease, filter 0.15s ease;
	}
	&:hover {
		background-color: rgba(0, 0, 0, 0.18) !important;
	}
	&:hover svg {
		transform: scale(1.15);
		filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.35));
	}
`;

export default IconButtonStyled;
